import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ImageService
{

  constructor(private http: HttpClient) { }

  public getImage(imageUrl: string): Observable<Blob>
  {
    return this.http.get(imageUrl, { responseType: 'blob' });
  }
}
